<div class="pagination-btn">
  <div class="navigation-items">
    <ex-button
      type="secondary"
      variant="raised"
      size="x-large"
      icon="arrow-left-fill"
      (click)="onPageClick(currentPage - 1)"
      [disabled]="currentPage === 1"
    >
      {{ 'button.prev' | translate }}
    </ex-button>
    @for (pageIndex of listOfPage; track pageIndex; let i = $index) {
      @if (i === 0) {
        <div class="align-self-center item active" [ngClass]="{ active: currentPage === pageIndex }" (click)="onPageClick(pageIndex)">
          <a class="">{{ pageIndex }}</a>
        </div>
      }
      @if (currentPage >= maxNbPagesConsecutive && i === 3 && i < nbPages && nbPages > maxNbPagesShow) {
        <div class="align-self-center item">
          <a class="">...</a>
        </div>
      }
      @if ((showWhenInFirstPages(pageIndex) || showWhenInLastPages(pageIndex) || showNextPrevPage(pageIndex)) && notShowFirstLastPage(i)) {
        <div class="align-self-center item" [ngClass]="{ active: currentPage === pageIndex }" (click)="onPageClick(pageIndex)">
          <a class="">{{ pageIndex }}</a>
        </div>
      }
      @if (currentPage <= nbPages - maxNbPagesConsecutive + 1 && i === nbPages - 4 && nbPages > maxNbPagesShow) {
        <div class="align-self-center item">
          <a class="">...</a>
        </div>
      }
      @if (i === nbPages - 1) {
        <div class="align-self-center item" [ngClass]="{ active: currentPage === nbPages }" (click)="onPageClick(pageIndex)">
          <a class="">{{ nbPages }}</a>
        </div>
      }
    }
    <ex-button
      type="secondary"
      variant="raised"
      size="x-large"
      icon="arrow-right-fill"
      iconPosition="right"
      (click)="onPageClick(currentPage + 1)"
      [disabled]="currentPage === nbPages"
    >
      {{ 'button.next' | translate }}
    </ex-button>
  </div>
</div>
